import { useEffect, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';

import api from '../api/api';
import BackgroundImage from '../assets/img/main-bg-pg.svg';
import LoginImage from '../assets/img/login-page-img.svg';
import '../assets/style/LoginScreen.css';

const LogoIcon = (props) => (
  <svg fill="none" height="100%" viewBox="0 0 24 24" width="100%" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path opacity="0.16" d="M7.242 11.083c.449-1.674 2.17-3.394 3.843-3.843l10.434-2.796c1.673-.448 2.666.545 2.218 2.218L20.94 17.096c-.449 1.674-2.17 3.394-3.843 3.843L6.664 23.735c-1.673.448-2.666-.545-2.218-2.218l2.796-10.434Z" fill="#6366F1"></path>
    <path d="M3.06 6.9c.448-1.674 2.168-3.394 3.842-3.843L17.336.261c1.673-.448 2.667.545 2.218 2.218l-2.796 10.434c-.449 1.674-2.169 3.394-3.843 3.843L2.481 19.552C.808 20-.185 19.007.263 17.334L3.06 6.9Z" fill="#6366F1"></path>
  </svg>
);

const LottieAnimation = () => (
  <Box sx={{ width: '70%', margin: '0px auto' }}>
    <img src={LoginImage} alt="" style={{ width: '100%' }} />
  </Box>
);

export default function EmailAuthenticationConfirm() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('Confirming Email Authentication...');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Confirmation token is missing.');
      return;
    }

    let isMounted = true;

    api.post('/email-authentication/confirm', { token })
      .then((response) => {
        if (!isMounted) {
          return;
        }

        setStatus('success');
        setMessage(response.data?.message || 'Email Authentication enabled successfully.');
      })
      .catch((error) => {
        if (!isMounted) {
          return;
        }

        setStatus('error');
        setMessage(error.response?.data?.message || 'Failed to confirm Email Authentication.');
      });

    return () => {
      isMounted = false;
    };
  }, [token]);

  const hasSession = !!sessionStorage.getItem('accessToken');

  return (
    <div className="login-screen-container">
      <div className="login-left-panel" style={{ backgroundImage: `url(${BackgroundImage})` }}>
        <div className="login-left-content">
          <Typography variant="h4" className="login-title">
            Welcome to PalladiumWallet
          </Typography>
          <Typography className="login-subtitle">
            Email Authentication protects your account from unauthorized access.
          </Typography>
          <LottieAnimation />
        </div>
      </div>

      <div className="login-right-panel">
        <div className="login-form-container">
          <a href="/" className="logo-link">
            <div className="logo-icon-wrapper">
              <LogoIcon />
            </div>
            <Typography variant="h6" className="logo-text">
              PalladiumWallet
            </Typography>
          </a>

          <div className="login-header">
            <Typography variant="h5" className="login-header-title">
              Email Authentication
            </Typography>
            <Typography className="login-header-subtitle">
              {message}
            </Typography>
          </div>

          {status === 'success' && <Typography className="success-message">{message}</Typography>}
          {status === 'error' && <Typography className="error-message">{message}</Typography>}

          <div className="form-spacer" />
          <Button
            fullWidth
            size="large"
            variant="contained"
            className="continue-button"
            disabled={status === 'loading'}
            onClick={() => navigate(hasSession ? '/dashboard/account-settings?tab=security' : '/')}
          >
            {hasSession ? 'Back to security settings' : 'Back to login'}
          </Button>
        </div>
      </div>
    </div>
  );
}
